<template>
	<div class="body-container" id="h-box" @click="closePop">
		<Header :headerMini="headerMini" v-if="!headerMini"></Header>
		<div id="maincontent" class="main page-careers-landing" rel="main">
			<div class="page-header-options">
				<div class="page-header-breadcrumb">
					<div class="breadcrumb-nav breadcrumb-nav-composed">
						<ul class="nav-links">
							<li class="nav-link" @click="goHome">
								<a ></a>
							</li>
							<li class="nav-link">
								<span>Careers</span>
							</li>
						</ul>

					</div>
				</div>
			</div>
			<!-- Job Search Wizard -->
			<div class="page-header-background-image">
				<div class="background-image background-image-desktop">
				</div>
				<div class="background-image background-image-mobile"></div>
				<div class="content">
					<h1 class="page-title page-title-large">Careers</h1>
					<div class="copy">Looking for a career at Baker McKenzie?</div>
					<div class="help-prompt">
						<span class="prompt-text">Help me find</span>
						<div class="drop-down-menu-filters " @click.stop="showFind">
							<div class="current-value">{{findtxt}}</div>
							<div class="drop-down" v-if="findSta">
								<label for="searchfiltertype" class="accessible-label">Help me find</label>
								<ul class="options position-options" name="searchfiltertype">
									<li class="option" v-for="(item,index) in findList" @click.stop="selectFind(item)">{{item}}</li>
								</ul>
							</div>
						</div> <span class="prompt-text">opportunities in</span>
						<div class="drop-down-menu-filters text-filterable" @click.stop="showOpportunities">
							<div class="current-value" >{{Opportunitiestxt}}</div>
							<div class="drop-down" style="top: 35px;" v-if="OpportunitiesSta">
								<label for="searchfiltertype" class="accessible-label">opportunities in</label>
								<ul class="options country-options">
									<li class="option" v-for="(item,index) in OpportunitiesList" @click.stop="selectOpportunities(item)">{{item}}</li>
								</ul>
							</div>
						</div>
					</div>
					<a id="opportunities-link" style="color:white;">
						<button id="opportunities-button" class="button-red">View Opportunities</button>
					</a>
				</div>
			</div>
			<!-- Navigation Jump Links -->
			<div class="jump-bar-nav">
				<div class="page-wrapper">
					<div class="label">Jump To</div>
					<div class="current-selection">Why Baker McKenzie?</div>
					<ul class="jump-buttons">
						<li class="jump-button " @click="jumpNav(1)">
							<button class="button-red" type="button">Why Baker McKenzie?</button>
						</li>
						<li class="jump-button " @click="jumpNav(2)">
							<button class="button-red" type="button">Global Opportunities</button>
						</li>
						<li class="jump-button " @click="jumpNav(3)">
							<button class="button-red" type="button">Inclusion, Diversity &amp; Equity at Baker
								McKenzie</button>
						</li>
					</ul>
				</div>
			</div>

			<div class="global-module-page-wrapper global-module">
				<div class="careers-jump-module">
					<div class="careers-jump-module-content">
						<h2 class="module-header">Why Baker McKenzie?</h2>
						<div class="tabs-module global-module tabs-module--has-image">
							<div class="tabs-module-image">
								<img src="../../assets/test/41.jpeg"
									alt="camping at night">
							</div>
							<div class="global-module-wrapper">
								<div class="tabs-panel-module js-tabs-panel-module">

									<div class="tabs-panel-nav js-tabs-panel-nav">
										<button class="tabs-panel-nav-toggle js-tabs-panel-nav-trigger">Who We
											Are</button>
										<ul class="tabs-panel-nav-list js-tabs-panel-nav-list">
											<li class="tabs-panel-nav-item">
												<button data-href="#tabcontentone" aria-controls="tabcontentone"
													class="tabs-panel-nav-link js-tabs-panel-nav-link is-selected"
													role="button">Who We Are</button>
											</li>
											<li class="tabs-panel-nav-item">
												<button data-href="#whatwelookfor" aria-controls="whatwelookfor"
													class="tabs-panel-nav-link js-tabs-panel-nav-link"
													role="button">What We
													Look For</button>
											</li>
											<li class="tabs-panel-nav-item">
												<button data-href="#professionaldevelopmentprograms"
													aria-controls="professionaldevelopmentprograms"
													class="tabs-panel-nav-link js-tabs-panel-nav-link"
													role="button">Professional Development Programs</button>
											</li>
											<li class="tabs-panel-nav-item">
												<button data-href="#developmentframework"
													aria-controls="developmentframework"
													class="tabs-panel-nav-link js-tabs-panel-nav-link"
													role="button">Development
													Framework</button>
											</li>
										</ul>
									</div>



									<div class="tabs-panels-all js-tabs-panel-all" style="">
										<a class="tab-anchor" id="tabcontentone" target="_blank"></a>
										<div class="tabs-panel js-tabs-panel is-active-panel">

											<div data-module-id="1a415066-a8d2-4dc9-815f-969e1ae4864c"
												class="js-overview-expand">

												<div class="overview-intro description rte no-expand-text">
													<p>We are different from other law firms in the way we think, work
														and behave. Global in our outlook and curious by nature, we are
														often the first to recognize changes in the market and respond
														with new and better ways to serve clients.</p>
													<p>Today the global business community is more interconnected than
														ever before, and clients need us to work across traditional
														practice, sector and market lines to mitigate risk and maximize
														opportunity. Our integrated solutions, underpinned by deep
														expertise and innovative technology, represent a new frontier
														for legal advice.</p>
													<p>For 10 consecutive years we have been named the world's strongest
														law firm brand by Acritas. This is because we don’t stand still
														— striving to be the best in all we do and thinking bigger,
														faster and further on behalf of clients. We know the value of
														our people in sustaining this success and so we're committed to
														offering the platform to nurture this talent.</p>
												</div>

											</div>
										</div>
										<a class="tab-anchor" id="whatwelookfor" target="_blank"></a>
										<div class="tabs-panel js-tabs-panel">

											<div data-module-id="31fac74e-ac76-410d-8cd4-da1817405342"
												class="js-overview-expand">

												<div class="overview-intro description rte no-expand-text">
													<p>We want individuals who can combine an impressive academic track
														record with excellent technical skills. Personal qualities
														matter — we look for engaged global citizens, critical thinkers
														and problem solvers. These qualities mean you can make
														connections across traditional practice, sector and market
														lines, and can process information, finding connections in
														complex situations to offer real insight and foresight to
														clients. Importantly, we want people who thrive in diverse teams
														where friendship is valued.</p>
												</div>

											</div>
										</div>
										<a class="tab-anchor" id="professionaldevelopmentprograms" target="_blank"></a>
										<div class="tabs-panel js-tabs-panel">

											<div data-module-id="acdefe37-92da-4a83-9021-4b0912dfd0a4"
												class="js-overview-expand">

												<div class="overview-intro description rte no-expand-text">
													<p>We actively promote a culture of learning within the Firm, as
														employees are encouraged to expand their knowledge and expertise
														throughout their careers – this culture of learning is
														underpinned by our comprehensive Development Framework.</p>
													<p>Our world-class learning programs will help you develop as far
														and as fast as your talents and drive will take you, be it at
														entry, associate or partner level. We have over 15 global
														milestone training programs, attended by over 400 lawyers each
														year, aimed at supporting you through your career, including:
													</p>
													<ul>
														<li>Partner Leadership Program - A 12-month program tailored to
															the needs of our leaders</li>
														<li>New Partner Program - A program to aid your transition to
															the manager role</li>
														<li>Mid Level and Senior Associate Training Program - Regional
															associate courses designed to strengthen networks and build
															relationships with colleagues</li>
														<li>Lateral Partners - A program that encourages partners to
															inspire, coach and mentor</li>
													</ul>
													<p>Our commitment to excellence also explains why more of our
														lawyers are included as leading lawyers in the Chambers Global
														Guide to the World's Best Lawyers than any other Global 20 law
														firm.</p>
												</div>

											</div>
										</div>
										<a class="tab-anchor" id="developmentframework" target="_blank"></a>
										<div class="tabs-panel js-tabs-panel">

											<div data-module-id="bd55042c-e81b-4efd-aa54-f1a94d0a46ec"
												class="js-overview-expand">

												<div class="overview-intro description rte no-expand-text">
													<p>Our Development Framework outlines the skills and personal
														qualities you need to be successful when working here. This
														framework informs how we recruit, develop and manage our talent,
														with specific paths set our for attorneys, business services
														roles and secretaries. It also gives you a comprehensive
														overview of what high performance looks like in the Firm. This
														living document offers a clear roadmap to success, and we'll be
														there every step of the way to help you fulfil your potential.
														We have a deep understanding of the culture of business the
														world over and are able to bring the talent and experience
														needed to help you be successful. Harvard Business School has
														selected the framework as one of its best practice case studies
														on talent management.</p>

												</div>

											</div>
										</div>
									</div>

								</div>
							</div>
						</div>


						<button class="button-text button-back-top js-button-back-top" @click="goTop">Back To Top</button>
					</div>
				</div>
			</div>
			<div class="global-module-page-wrapper global-module">
				<div class="careers-jump-module">
					<div class="careers-jump-module-content">
						<h2 class="module-header">Global Opportunities</h2>
						<div class="tabs-module global-module tabs-module--has-image">
							<div class="tabs-module-image">
								<img src="../../assets/test/42.webp">
							</div>
							<div class="global-module-wrapper">
								<div class="tabs-panel-module js-tabs-panel-module">

									<div class="tabs-panel-nav js-tabs-panel-nav">
										<button class="tabs-panel-nav-toggle js-tabs-panel-nav-trigger">Explore Our
											World</button>
										<ul class="tabs-panel-nav-list js-tabs-panel-nav-list">
											<li class="tabs-panel-nav-item">
												<button data-href="#tabcontent2" aria-controls="tabcontent2"
													class="tabs-panel-nav-link js-tabs-panel-nav-link is-selected"
													role="button">Explore Our World</button>
											</li>
											<li class="tabs-panel-nav-item">
												<button data-href="#internationalclerkships"
													aria-controls="internationalclerkships"
													class="tabs-panel-nav-link js-tabs-panel-nav-link"
													role="button">International Clerkships</button>
											</li>
											<li class="tabs-panel-nav-item">
												<button data-href="#lawstudents" aria-controls="lawstudents"
													class="tabs-panel-nav-link js-tabs-panel-nav-link" role="button">Law
													Students</button>
											</li>
											<li class="tabs-panel-nav-item">
												<button data-href="#graduatelegalstudies"
													aria-controls="graduatelegalstudies"
													class="tabs-panel-nav-link js-tabs-panel-nav-link"
													role="button">Graduate
													Legal Studies</button>
											</li>
											<li class="tabs-panel-nav-item">
												<button data-href="#associatetrainingprogram"
													aria-controls="associatetrainingprogram"
													class="tabs-panel-nav-link js-tabs-panel-nav-link"
													role="button">Associate
													Training Program</button>
											</li>
										</ul>
									</div>



									<div class="tabs-panels-all js-tabs-panel-all" style="">
										<a class="tab-anchor" id="tabcontent2" target="_blank"></a>
										<div class="tabs-panel js-tabs-panel is-active-panel">

											<div data-module-id="4ed6cd7d-7109-4dc8-b151-a802e932927f"
												class="js-overview-expand">

												<div class="overview-intro description rte no-expand-text">
													<p>Overseas relationships are the building blocks of our global
														business and the seamless way in which we work with clients.
														We
														will support your career aspirations by offering access to
														formal mobility programs where possible. These programs give
														you
														the chance to travel to other countries, engage with global
														clients, and develop your networks.</p>
													<p>Most formal programs are designed for our lawyers, but we
														have
														many examples of Business Services employees who have carved
														out
														a career in multiple jurisdictions with the Firm.</p>
												</div>

											</div>
										</div>
										<a class="tab-anchor" id="internationalclerkships" target="_blank"></a>
										<div class="tabs-panel js-tabs-panel">

											<div data-module-id="6c45c217-9b50-4800-91a4-353e6cc1915f"
												class="js-overview-expand">

												<div class="overview-intro description rte no-expand-text">
													<p>We award International Clerkships to law students and recent
														graduates interested in exploring a career in law.
														Recipients
														typically work with lawyers from two different countries
														over a
														12-week period.</p>
													<p>The program offers you the chance to compare legal practice
														in
														two distinctive legal jurisdictions, become familiar with a
														legal culture different from your own and see our
														international
														practice from the inside.</p>
													<p>An International Clerkship is only available if you wish to
														apply
														for a permanent work contract. Clerks are selected on the
														basis
														of their legal ability, interest in pursuing an
														international
														practice and their ability to speak English, as well as the
														working languages of the locations where they will work (if
														other than English).</p>
													<p>Candidates typically need at least two years' formal legal
														training prior to their clerkship. Candidates in the US may
														qualify if they have completed two years in an ABA-approved
														law
														school JD curriculum by the time their clerkship &nbsp;is
														set to
														finish. Each clerkship comes with an attractive salary and
														travel expenses.</p>
													<p>Candidates interested in this opportunity need to complete a
														letter of application, include a full CV (including
														university
														exam results), two letters of reference from law professors
														or
														other appropriate persons qualified to evaluate your work,
														and a
														detailed statement of the educational value to you of an
														International Clerkship</p>
													<h4>Application deadlines</h4>
													<p><strong>September</strong>: Argentine, Brazilian, Chilean and
														Colombian candidates<br>
														<strong>November</strong>: US candidates<br>
														<strong>January</strong>: All other candidates
													</p>
												</div>

											</div>
										</div>
										<a class="tab-anchor" id="lawstudents" target="_blank"></a>
										<div class="tabs-panel js-tabs-panel">

											<div data-module-id="1872a12d-1539-4024-a4da-38e0635cbed0"
												class="js-overview-expand">

												<div class="overview-intro description rte no-expand-text">
													<p>Across the Firm, we offer opportunities for law students and
														graduates to work alongside our global network of lawyers
														through various programs and work schemes. At Baker
														McKenzie,
														everyone has a vital role to play and everyone’s voice is
														important. We pride ourselves on nurturing one
														high-performing
														team and are committed to the development of our people. We
														invite you to explore offices and practices that are of
														interest
														you.</p>
													<p><a rel="noopener noreferrer"
															href="https://www.bakermckenzie.com/en/locations/north-america/united-states/summer-associate-program"
															target="_blank"><span class="link--bold">View our United
																States Summer Associate Program</span></a>
													</p>
													<p><a rel="noopener noreferrer"
															href="https://www.bakermckenzie.com/en/locations/north-america/canada/canada-student-program"
															target="_blank"><span class="link--bold">View our Canada
																Student Program</span></a>
													</p>
												</div>

											</div>
										</div>
										<a class="tab-anchor" id="graduatelegalstudies" target="_blank"></a>
										<div class="tabs-panel js-tabs-panel">

											<div data-module-id="5291f7ab-ad03-4ba5-9434-e5715342d177"
												class="js-overview-expand">

												<div class="overview-intro description rte no-expand-text">
													Every year we provide a number of scholarships to our associates
													for
													full-time graduate legal study outside their home jurisdictions,
													usually in a college or university near one of our offices.
													These
													prestigious awards are open to individuals who have been with us
													for
													at least two years and the program of study must include the
													completion of a graduate law degree (LLM, MCL, or similar
													degree).
													Each scholarship is awarded for a minimum of 12 months of study.
												</div>

											</div>
										</div>
										<a class="tab-anchor" id="associatetrainingprogram" target="_blank"></a>
										<div class="tabs-panel js-tabs-panel">

											<div data-module-id="42183bb3-86a8-41ea-b457-a583ac55bf8a"
												class="js-overview-expand">

												<div class="overview-intro description rte no-expand-text">
													<p>The<strong> Associate Training Program (ATP)</strong> is our
														flagship mobility program, having been established over 30
														years
														ago. Hundreds of associates have participated in this
														program to
														date.</p>
													<p>The ATP provides our associates with an excellent opportunity
														for
														development through active participation in the daily
														working
														life of the host office and being exposed to a wide range of
														clients and matters to enhance their on-the-job learning.
														ATP
														participants will also benefit from all the training and
														development opportunities offered by their hosts and we
														actively
														encourage them, wherever possible, to take LL.M courses,
														external Executive Education programs or similar programs
														available in the host jurisdiction.</p>
													<p>The program is open to associates who have been with us for
														at
														least two years and choice of location may be influenced by
														-
														but will not be dependent upon - an associate's interest in
														a
														country, ability to speak another language, the business
														need of
														one of our clients or the need of one of our practice
														groups.
													</p>
												</div>

											</div>
										</div>
									</div>

								</div>
							</div>
						</div>


						<div class="region-nav-wrapper">
						</div>
						<button class="button-text button-back-top js-button-back-top" @click="goTop">Back To Top</button>
					</div>
				</div>
			</div>
			<div class="global-module-page-wrapper global-module">
				<!-- Diversity and Inclusion -->
				<div data-module-id="overviewModule" class="overview-module careers-overview js-overview-expand">
					<div data-jump-destination="" class="careers-jump-module">
						<div class="global-module-wrapper careers-jump-module-content">
							<h2 class="module-header">Inclusion, Diversity &amp; Equity at Baker McKenzie</h2>

							<div class="overview-intro description">
								<p>At Baker McKenzie, we take a holistic view of Inclusion, Diversity &amp; Equity
									(ID&amp;E) — asking how we can multiply our impact and deliver for our people,
									our
									clients and our industry. Our global community is made up of people from many
									different backgrounds, creeds, colors, ethnicities, religions, sexual
									orientations,
									gender identities and expressions, and abilities. We embrace and celebrate this
									human difference by cultivating an inclusive workplace and culture of respect.
									To
									ensure we maintain a focused agenda, we have a committee comprised of members
									from
									all four of our world regions that is chaired by Kirsty Wilson from our
									Executive
									Committee.</p>
								<p><strong>Better experiences for our people </strong><br>
									We want all of our people to thrive at Baker McKenzie — as professionals,
									individuals and global citizens. This means giving credit where it’s due and
									incentivizing inclusive behaviors, providing equal access to opportunities for
									career progression, being a flexible workplace, and offering an intellectually
									rich
									and supportive environment.</p>
								<p><strong>Better outcomes for our clients </strong><br>
									In an increasingly interconnected business community, opportunities and risks
									spill
									across different markets, sectors and areas of law. Access to the brightest
									legal
									minds, who bring diverse and connected perspectives to complex legal and
									commercial
									questions, is key to business success. We believe ID&amp;E unlocks innovation
									and
									enables stronger guidance and seamless solutions. </p>
								<p><strong>Driving change together </strong><br>
									Improving ID&amp;E in our profession, and across the business community, cannot
									be
									done in silos. Sustainable progress requires partnership. As well as
									collaborating
									with clients on specific mentorship, sponsorship and education projects, we join
									clients and peers in supporting associations and community initiatives focused
									on
									ID&amp;E around the world, and contribute data and ideas to advance ID&amp;E
									progress.</p>
							</div>
							<div class="download-prompt">

								<div class="instructions">Find Out More About Our ID&amp;E Initiatives</div>
								<a>
									<button class="button-red">Visit Our Inclusion, Diversity &amp; Equity
										Page</button>
								</a>
							</div>
							<button class="button-text button-back-top js-button-back-top" @click="goTop">Back To Top</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="global-footer">
			<div class="communication-footer hide-print">
				<ul class="social-links">
					<li class="social-link"><a class="iconfont icon-tuite" target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-f" target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-weibiaoti1"target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-weixin"target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-wifi"target="_blank"></a></li>
				</ul>
			</div>
			<div class="footer-nav hide-print">
				<ul class="utility-links">
					<li class="utility-link"><a >Disclaimers</a></li>
					<li class="utility-link"><a >Privacy &amp; Cookies Statement</a></li>
					<li class="utility-link"><a  class="ot-sdk-show-settings" title="Manage Choices">Cookie
							Preferences</a></li>
					<li class="utility-link"><a >CCPA Privacy Disclosures</a></li>
					<li class="utility-link"><a >Contact Us</a></li>
					<li class="utility-link"><a>Media Contacts</a></li>
					<li class="utility-link"><a >Blogs</a></li>
					<li class="utility-link"><a>BM Online</a></li>
				</ul>
		
			</div>
			<div class="copyright">
				<p><span>Attorney Advertising | © 2024 Baker McKenzie</span></p>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '../../components/header.vue'
	export default {
		components: {
			Header
		},
		data() {
			return {
				metaHeight:15,  //最小滚动距离
				metaTime: 10,   //最小执行时间
				headerMini: false,
				thresholdHeight: 100,
				OpportunitiesSta:false,
				findSta:false,
				findtxt:'',
				Opportunitiestxt:'',
				findList:['Business Services','Entry Level Associate','Experienced Associate','Internship','Trainee Lawyer'],
				OpportunitiesList:['Abu Dhabi','Africa','Almaty','Amsterdam','Antwerp','Argentina','Asia Pacific','Australia','Austria','Bahrain','Bangkok','Barcelona','Beijing','Belfast','Center','Buenos Aires Center','Cairo','Canada','Caracas','Casablanca','Chicago','Chile','China','Dallas','Doha','Dusseldorf','Egypt','France','Frankfurt','Guadalajara','Hong Kong','Jeddah','Johannesburg','Korea','Madrid','Malaysia','Singapore','Sydney','Taipei','Warsaw','Zurich']
			}
		},
		mounted() {
			window.addEventListener('scroll', this.checkScrollPosition);
		},
		beforeDestroy() {
			// 在组件销毁前移除滚动监听
			window.removeEventListener('scroll', this.checkScrollPosition);
		},
		methods: {
			checkScrollPosition() {
				this.headerMini = window.scrollY >= this.thresholdHeight;
			},
			goHome(){
				this.$router.replace('/'); 
			},
			showOpportunities(){
				this.OpportunitiesSta = true
			},
			showFind(){
				this.findSta = true
			},
			selectFind(e){
				this.findSta = false
				this.findtxt = e
			},
			selectOpportunities(e){
				this.OpportunitiesSta = false
				this.Opportunitiestxt = e
			},
			jumpNav(type){
				var targetHeight = 0
				if(type == 1){
					targetHeight = 1000
				}
				if(type == 2){
					targetHeight = 2000
				}
				if(type == 3){
					targetHeight = 2800
				}
				let x = targetHeight - document.documentElement.scrollTop;
				document.documentElement.scrollTop += x%this.metaHeight;
				x -= x%this.metaHeight;
				const goto = setInterval(() => { // 建立执行操作的定时器
				  document.documentElement.scrollTop  += this.metaHeight; // 控制移动滚动条
				  x-= this.metaHeight; // 缩减高度差
				  if (x == 0) { // 到达指定位置后清除定时器
				    clearInterval(goto); //清除定时器
				  }
				}, this.metaTime);
			},
			goTop(){
				let x = document.documentElement.scrollTop - 800;
				// 先减去余数，保证高度差能整除设定的最小移动单位
				document.documentElement.scrollTop -= x%this.metaHeight;
				x -= x%this.metaHeight;
				const goto = setInterval(() => {
				  document.documentElement.scrollTop -= this.metaHeight;
				  x-= this.metaHeight;
				  if (x == 0) {
				    clearInterval(goto); //清除定时器
				  }
				}, 1);
			},
			closePop(){
				this.OpportunitiesSta = false
				this.findSta = false
			}
		}
	}
</script>
<style src="@/assets/main.css"  scoped></style>
<style lang='scss' scoped>
	.body-container {
		width: 100%;
		/* min-width: 1280px; */
		min-height: 100vh;
		overflow: hidden;
		position: relative;
		background-color: #fff;
	}

	.page-careers-landing {
		margin-bottom: 3.75em;
	}

	.main {
		padding-top: 82px;
	}

	.page-header-options {
		background: linear-gradient(287.72deg, #ad122a -2.45%, #790123 185.33%);
		padding: 0.375em 0;
		text-align: right;
	}

	.breadcrumb-nav {
		padding: 0.375em 0;
	}

	.page-header-options .page-header-breadcrumb {
		padding-right: 1.5em;
		padding-left: 1.5em;
		margin-left: auto;
		margin-right: auto;
		height: 25px;
	}

	.page-header-options .breadcrumb-nav {
		float: left;
		text-align: left;
		padding: 0;
	}

	.breadcrumb-nav .nav-links {
		list-style-type: none;
		white-space: nowrap;
		overflow: hidden;
		display: block;
		text-overflow: ellipsis;
		margin: 0;
		padding: 0;
	}

	.breadcrumb-nav .nav-link {
		display: inline;
		color: #FFF;
		font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
		font-weight: normal;
		font-style: normal;
		font-size: 0.875em;
		letter-spacing: 1px;
		
		.icon-shouye {
			color: #fff;
			font-size: 15px;
			cursor: pointer;
		}
		
		.icon-xiangyou1 {
			font-size: 13px;
			margin: 0 5px;
		}
	}

	a {
		color: #ad122a;
		transition: color 0.4s, background-color 0.4s;
	}

	.breadcrumb-nav .nav-link:first-of-type a {
		font-size: 0;
	}

	.breadcrumb-nav .nav-link a {
		color: inherit;
	}

	.page-header-background-image {
		position: relative;
		padding: 8.125em 0 9.375em;
	}

	.page-header-background-image .background-image {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: 50% 50%;
	}
	.page-header-background-image .background-image-desktop {
		background-image: url('../../assets/test/33.webp');
	}
	.page-header-background-image .background-image-mobile {
		display: none;
		background-image: url('../../assets/test/sj.jpeg');
	}

	.page-header-background-image .content {
		position: relative;
		background-color: rgba(253, 253, 253, 0.9);
		max-width: 50.625em;
		margin-left: auto;
		margin-right: auto;
		padding: 3.75em 2.5em 4.6875em;
		text-align: center;
		z-index: 3;
	}

	.page-header-background-image .content .page-title {
		font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
		font-weight: normal;
		font-style: normal;
		font-weight: bold;
		line-height: 1;
		color: #FFF;
		font-size: 2.25em;
		color: #000;
	}

	.page-header-background-image .content .copy {
		text-align: center;
		font-size: 1.25em;
		margin-top: 1.6em;
		letter-spacing: 1px;
	}

	.page-header-background-image .content .help-prompt {
		margin-top: 2em;
	}

	.page-header-background-image .content .prompt-text {
		font-size: 1.25em;
		display: inline-block;
		vertical-align: top;
		letter-spacing: 1px;
	}

	.drop-down-menu-filters,
	.drop-down-menu-filters-insights,
	.drop-down-menu-filters-people {
		position: relative;
		cursor: pointer;
		display: inline-block;
		z-index: 8;
	}

	.page-header-background-image .content .drop-down-menu-filters {
		min-width: 12.5em;
		margin: 0 .5em;
		z-index: 2;
	}

	.page-header-background-image .content .drop-down-menu-filters.text-filterable {
		z-index: 1;
	}

	.drop-down-menu-filters .current-value,
	.drop-down-menu-filters-insights .current-value,
	.drop-down-menu-filters-people .current-value {
		border-bottom: 2px solid #ad122a;
		text-align: left;
		position: relative;
		color: #ad122a;
		font-size: 1.25em;
		height: 30px;
		line-height: 1.5;
		padding-right: 1em;
		padding-left: .5em;
		overflow: hidden;
	}
	.drop-down-menu-filters .current-value .icon-xiangxia {
		float: right;
		font-weight: bold;
	}

	.drop-down-menu-filters .drop-down,
	.drop-down-menu-filters-insights .drop-down,
	.drop-down-menu-filters-people .drop-down {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		display: block;
	}

	.page-header-background-image .content .page-title.page-title-large {
		font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
		font-weight: normal;
		font-style: normal;
		font-weight: bold;
		line-height: 1;
		color: #FFF;
		font-size: 3em;
		color: #000;
	}

	.button-red,
	#close-video {
		text-transform: uppercase;
		transition: background-color 0.4s;
		color: #FFF;
		padding: 1em 2em;
		background-color: #ad122a;
		line-height: 1em;
		display: inline-block;
		font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
		font-weight: normal;
		font-style: normal;
		font-weight: bold;
		font-size: 15px;
		letter-spacing: 1px;
	}

	.page-header-background-image .button-red {
		margin-top: 2.8125em;
		margin-left: auto;
		margin-right: auto;
		display: block;
		font-size: 17px;
		letter-spacing: 1px;
		cursor: pointer;
	}
	.page-header-background-image .button-red:hover {
		background-color:#780123 ;
	}

	.jump-bar-nav {
		text-align: center;
		background-color: #FDFDFD;
	}

	.page-wrapper {
		max-width: 79.875em;
		padding-right: 1.5em;
		padding-left: 1.5em;
		margin-left: auto;
		margin-right: auto;
	}

	.jump-bar-nav .page-wrapper {
		position: relative;
		width: auto;
		display: inline-block;
		padding-left: 4em;
	}

	.jump-bar-nav .label {
		display: inline-block;
		position: absolute;
		left: 0;
		top: 50%;
		margin-top: -.75em;
		margin-right: 0.625em;
		font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
		font-weight: normal;
		font-style: normal;
		font-weight: bold;
		text-transform: uppercase;
	}

	.jump-bar-nav .current-selection {
		display: none;
	}

	.jump-bar-nav .jump-buttons {
		display: inline-block;
		margin-left: 2em;
	}

	.jump-bar-nav .jump-button {
		display: inline-block;
		margin: 2em 0.5em;
		cursor: pointer;
	}

	button {
		background: none;
		border: none;
	}

	.global-module {
		padding-top: 3.75em;
		padding-bottom: 3.75em;
		background: none;
	}

	.module-header {
		color: #001A32;
		line-height: 1;
		text-align: center;
		font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
		font-weight: normal;
		font-style: normal;
		font-weight: bold;
	}

	h2,
	.h2 {
		font-size: 32px;
	}

	.tabs-module-image {
		/* margin: 0 calc(50% - 50vw); */
	}

	.tabs-module-image img {
		width: 100%;
		display: block;
	}

	.global-module-page-wrapper .global-module-wrapper {
		max-width: 79.875em;
		padding-right: 1.5em;
		padding-left: 1.5em;
		margin-left: auto;
		margin-right: auto;
		width: 90%;
	}

	.tabs-module--has-image .tabs-panel-module {
		margin-top: -250px;
	}

	.tabs-panel-nav-toggle {
		display: none;
		width: 100%;
		text-align: left;
	}

	.careers-jump-module .promo-content,
	.careers-jump-module .download-prompt,
	.careers-jump-module .tabs-panel-nav {
		margin-top: 2em;
		position: relative;
	}

	.careers-jump-module .tabs-panel-nav-list {
		border-bottom: 0 none;
	}

	.tabs-module--has-image .tabs-panel-nav-list {
		background-color: #ad122a;
		margin-bottom: 0;
	}

	.tabs-panel-nav-list {
		list-style-type: none;
		text-align: center;
	}

	.tabs-panel-nav-list .tabs-panel-nav-item {
		display: inline-block;
	}

	.tabs-panel-nav-list .tabs-panel-nav-link {
		font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
		font-weight: normal;
		font-style: normal;
		font-size: 1.25em;
		font-weight: 500;
		padding: 1em;
		line-height: 1.4;
		display: inline-block;
		position: relative;
	}

	.tabs-module--has-image .tabs-panel-nav-list .tabs-panel-nav-link {
		opacity: 0.6;
		color: #FFF;
	}

	.tabs-panel-nav-list .tabs-panel-nav-link.is-selected,
	.tabs-panel-nav-list .tabs-panel-nav-link:hover {
		color: #ad122a;
	}

	.tabs-panel-nav-list .tabs-panel-nav-item+.tabs-panel-nav-item {
		margin-left: .5em;
	}

	.tabs-panels-all {
		position: relative;
		overflow: hidden;
		margin: 0;
		background-color: #FFF;
		border: 1px solid #D2D2D2;
	}

	.tab-anchor {
		display: block;
		position: absolute;
		top: -80px;
		visibility: hidden;
	}

	.tabs-panel {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 3;
		visibility: hidden;
		opacity: 0;
		width: 100%;
		transition: opacity 0.6s cubic-bezier(0.86, 0, 0.07, 1);
		padding: 2.5em;
	}

	.tabs-panel.is-active-panel {
		position: relative;
		z-index: 5;
		top: auto;
		left: auto;
		opacity: 1;
		visibility: visible;
	}

	.tabs-module--has-image .tabs-panels-all {
		border: none;
	}

	.tabs-module--has-image .tabs-panel-nav-list .tabs-panel-nav-link.is-selected,
	.tabs-module--has-image .tabs-panel-nav-list .tabs-panel-nav-link:hover {
		opacity: 1;
		color: #FFF;
	}

	.tabs-panel .description {
		font-size: 1.125em;
		line-height: 1.55556em;
		padding: 0 1.5em;
	}

	.careers-jump-module .description {
		font-size: 1.125em;
		line-height: 1.55556em;
		padding-top: 3.75em;
		letter-spacing: 1px;
	}

	.careers-jump-module .tabs-module .description {
		padding-top: 0;
		letter-spacing: 1px;
	}

	.rte p {
		margin-bottom: 1em;
		margin-top: 1em;
	}

	.rte> :not(h1):not(h2):not(h3):not(h4):not(h5):not(button) {
		font-size: 18px;
	}

	.rte p:first-child {
		margin-top: 0;
	}

	.global-module .overview-intro p:first-child {
		margin-top: 0;
	}

	.button-back-top {
		color: #ad122a;
		font-weight: bold;
		text-transform: uppercase;
	}

	.careers-jump-module .button-back-top {
		font-size: 1.125em;
		margin: 2em auto 0 auto;
		display: block;
	}

	.region-nav-wrapper {
		list-style: none;
	}

	.overview-module.careers-overview {
		padding-top: 0;
	}
	.drop-down-menu-filters .options, .drop-down-menu-filters-insights .options, .drop-down-menu-filters-people .options {
		width: 100%;
	    max-height: 270px;
	    overflow-y: auto;
	    padding: 0;
	    margin: 0;
	}
	.drop-down-menu-filters .drop-down.show-drop-down, .drop-down-menu-filters-insights .drop-down.show-drop-down, .drop-down-menu-filters-people .drop-down.show-drop-down {
	    display: block;
	    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.25);
	}
	.accessible-label {
	    position: absolute;
	    left: -10000px;
	    top: auto;
	    width: 1px;
	    height: 1px;
	    overflow: hidden;
	}
	.drop-down-menu-filters .option, .drop-down-menu-filters .text-option, .drop-down-menu-filters .search-options, .drop-down-menu-filters-insights .option, .drop-down-menu-filters-insights .text-option, .drop-down-menu-filters-insights .search-options, .drop-down-menu-filters-people .option, .drop-down-menu-filters-people .text-option, .drop-down-menu-filters-people .search-options {
	    list-style-type: none;
	    font-size: 1.125em;
	    color: #ad122a;
	    background-color: #FDFDFD;
	    padding: 0.5625em;
	    text-align: center;
	    line-height: 1.5;
	}
	.drop-down-menu-filters .option:hover, .drop-down-menu-filters .text-option:hover, .drop-down-menu-filters .search-options:hover, .drop-down-menu-filters-insights .option:hover, .drop-down-menu-filters-insights .text-option:hover, .drop-down-menu-filters-insights .search-options:hover, .drop-down-menu-filters-people .option:hover, .drop-down-menu-filters-people .text-option:hover, .drop-down-menu-filters-people .search-options:hover {
	    background-color: #F0F0F0;
	}
	.page-header-background-image .content input.filter-input {
	    background-color: transparent;
	}
	input {
	    border: none;
	    padding: 0;
	}
	.careers-jump-module .promo-content, .careers-jump-module .download-prompt, .careers-jump-module .tabs-panel-nav {
	    margin-top: 56px;
		text-align: center;
	}
	.download-prompt .instructions {
	    margin-bottom: 0.46875em;
	    font-size: 2em;
	    font-weight: bold;
	}
	.global-footer, .global-footer-social {
	    font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
	    font-weight: normal;
	    font-style: normal;
	    background: linear-gradient(108.99deg, #ad122a -0.16%, #790123 153.62%);
	    padding-top: 4.375em;
	    padding-bottom: 3.125em;
		
		.communication-footer {
		    text-align: center;
			
			.social-links {
			    display: inline-block;
				
				.social-link {
				    display: inline-block;
				    margin-left: 1rem;
				    margin-right: 1rem;
				    vertical-align: middle;
				    font-size: 1.75em;
					
					a {
					    color: #FFF;
						vertical-align: -6.14286%;
						line-height: 1;
					}
					.iconfont {
						font-size: 32px;
					}
				}
			}
		}
		.footer-nav{
		    margin-left: 1.5em;
		    margin-right: 1.5em;
			border-top: 1px solid #cececd;
			max-width: 79.875em;
			padding: 1.5em 0 0;
			
			.utility-links{
			    font-size: 1.125em;
				display: flex;
				justify-content: space-between;
				
				.utility-link {
				    color: #FFF;
					display: inline-block;
					padding-right: 1em;
					
					a {
					    color: #FFF;
					}
				}
			}
		}
		.copyright {
			margin-left: 1.5em;
			margin-top: 1.5em;
			color: #FFF;
			max-width: 79.875em;
			margin-right: 1.5em;
			padding: 0;
			text-align: center;
		}
	}
	@media screen and (max-width: 47.9375em){
		.page-header-background-image .background-image-mobile {
			display: block;
			background-position: 35% 50%;
		}
		.page-header-background-image .content {
		    padding: 0;
		    background-color: transparent;
		}
		.jump-bar-nav {
		    text-align: left;
		}
		.jump-bar-nav .page-wrapper {
		    max-width: none;
		    padding-right: 0;
		    padding-left: 0;
		    margin-right: 0;
		    margin-left: 0;
		    width: 100%;
		}
		.jump-bar-nav .label {
		    display: block;
		    position: static;
		    transform: none;
		    width: 100%;
		    margin-top: 0;
		    padding: 1em 1.14286em;
		    font-size: 0.875em;
		    background-color: #f3f2ee;
		    border-top: 1px solid #cececd;
		    border-bottom: 1px solid #cececd;
		}
		.jump-bar-nav .current-selection {
		    display: block;
		    text-transform: uppercase;
		    font-size: 0.875em;
		    padding: 1em 1.14286em;
		    color: #ad122a;
		    background-color: #FDFDFD;
		    border-bottom: 1px solid #cececd;
		    cursor: pointer;
		    font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
		    font-weight: normal;
		    font-style: normal;
		    font-weight: bold;
		}
		.jump-bar-nav .jump-buttons {
		    margin-left: 0;
		    display: block;
		    position: absolute;
		    top: 100%;
		    left: 0;
		    width: 100%;
		    border-bottom: 1px solid #cececd;
		    display: none;
		    z-index: 10;
		}
		.global-module {
		    padding-top: 1.875em;
		    padding-bottom: 1.875em;
		}
		.careers-jump-module:last-child {
		    padding-bottom: 2.8125em;
		}
		.careers-jump-module {
		    padding-top: 2.8125em;
		}
		.global-module h2 {
		    font-size: 28px;
		}
		.global-module.global-module-page-wrapper .global-module-wrapper {
		    max-width: 79.875em;
		    padding-right: 1.5em;
		    padding-left: 1.5em;
		    margin-left: auto;
		    margin-right: auto;
		    width: 86%;
		}
		.global-module .tabs-panel-module {
		    margin-top: 3.75em;
		    margin-bottom: 3.75em;
		}
		.careers-jump-module .promo-content, .careers-jump-module .download-prompt, .careers-jump-module .tabs-panel-nav {
		    margin-top: 1.5em;
		}
		.tabs-panel-nav-toggle {
		    position: relative;
		    display: block;
		    text-transform: uppercase;
		    color: #FFF;
		    line-height: 1.21429em;
		    padding: 1em 1.14286em;
		    position: relative;
		    cursor: pointer;
		    border-bottom: 1px solid #F0F0F0;
		    background-color: #ad122a;
		    font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
		    font-weight: normal;
		    font-style: normal;
		    font-size: 0.875em;
		}
		.tabs-panel-nav .tabs-panel-nav-toggle {
		    padding-left: 1.5em;
		    padding-right: 1.5em;
		}
		.tabs-panel-nav-toggle {
			width: 87%;
		}
		.tabs-panel {
			width: 100%;
			padding: 1.5em 0;
		}
		.careers-jump-module .description, .careers-jump-module .button-back-top {
		    font-size: 12px;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .footer-nav .utility-links, .global-footer-social .footer-nav .utility-links {
		    display: -ms-flexbox;
		    display: flex;
		    -ms-flex-direction: row;
		    flex-direction: row;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    text-align: left;
		    padding: 0;
		    -ms-flex-align: center;
		    align-items: center;
		}
		.global-footer .footer-nav .utility-links .utility-link, .global-footer-social .footer-nav .utility-links .utility-link {
		    width: 38%;
		    padding-bottom: 1em;
		    padding-right: 0;
		    padding-left: 20px;
		    min-height: 40px;
		}
		.global-footer .copyright, .global-footer-social .copyright {
		    display: block;
		    text-align: center;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .communication-footer .social-links .social-link .iconfont, .global-footer-social .communication-footer .social-links .social-link .iconfont{
			font-size: 25px;
		}
		.main {
			padding-top: 63px;
		}
	}
</style>
